export default function () {
  if (document.querySelector('.profile-manage') !== null) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "profile-manage" */ '../_03_organisms/profile-manage'
    );
  }
}
